<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEdit="openEdit"
      @printer="printer"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <dict-select
          slot="left"
          ref="expoInfoSelect"
          v-model="expoInfoCode"
          :selectedLabel.sync="expoInfoName"
          url="/digitalCenter/expo/info/dictSelect"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
          size="small"
          filterable
          @loaded="expoInfoLoaded"
          @change="expoInfoChange"
        />
        <template #right>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openEdit({ type: 'choose' })"
            v-if="allow('B')"
          >
            {{ $l('form_label_choose_sample') || '已有展会样品选择' }}
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openEdit({ type: 'add' })"
            v-if="allow('A')"
          >
            {{ $l('btn_chooseSample') || '选择样品' }}
          </b-button>

          <el-badge
            v-if="allow('P')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="printer-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="printers"
              :disabled="!checkedRowCount"
            >
              {{ $l('btn_printer') || '标签打印' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="printer-button ml-2"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportData()"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </template>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      :expoSampleCode="editOptions.expoSampleCode"
      @reload="reload"
    />

    <choose-sample-dialog
      :visible.sync="chooseSampleVisible"
      type="checkbox"
      @confirm="sampleConfirm"
      :confirm-on-close="false"
    />
    <ChooseUsedSample
      :visible.sync="chooseUsedSampleVisible"
      :expoInfoCode="expoInfoCode"
      type="checkbox"
      @confirm="usedSampleConfirm"
      :confirm-on-close="false"
    />

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'digicenter-exposample' }"
      :exportOptions="{
        params: { listExpoSampleCode: chooseTemplateOptions.listCode },
        checkUrl: '/digitalCenter/expo/sample/printerCheck',
      }"
      @export-success="clearCheckboxRow"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import EditForm from '../edit-form'
import ChooseUsedSample from '../choose-used-sample/dialog.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import chooseTemplate from '@/views/digital/components/choose-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    EditForm,
    chooseTemplate,
    ChooseUsedSample,
  },
  data() {
    return {
      usePage: true,
      editOptions: { visible: false, expoSampleCode: '' },
      chooseSampleVisible: false,
      chooseUsedSampleVisible: false,
      expoInfoCode: '',
      expoInfoName: '',
      chooseTemplateOptions: { visible: false, listCode: [] },
      checkedRows: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  activated() {
    // 重新加载展会信息
    if (this.expoInfoCode) this.$refs.expoInfoSelect.init()
  },
  methods: {
    expoInfoLoaded(data) {
      if (this.expoInfoCode) return
      if (!data || !data.length) return
      const { value: expoInfoCode, label: expoInfoName } = data[0]
      if (!expoInfoCode) return
      this.$refs.header.reset()
      this.expoInfoCode = expoInfoCode
      this.expoInfoName = expoInfoName
      this.$refs.header.query()
    },
    expoInfoChange() {
      this.clearCheckboxRow()
      this.$refs.header.reset()
      this.$refs.header.query()
    },
    getData(form) {
      if (!this.expoInfoCode) return
      this.loading = true
      this.$api
        .expoSampleListApi({
          ...form,
          ...this.page,
          expoInfoCode: this.expoInfoCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEdit({ type, data = {} }) {
      if ('add' === type) return (this.chooseSampleVisible = true)
      if ('choose' === type) return (this.chooseUsedSampleVisible = true)
      const { expoSampleCode } = data
      this.editOptions = { visible: true, type, expoSampleCode }
    },
    async sampleConfirm(data) {
      if (!data || !data.length) return

      const confirm = await this.$confirm(
        `${this.$l('confirm_addSample') || '是否将选中的样品添加到该展厅？'}【${
          this.expoInfoName
        }】`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const listSampleCode = data.map((item) => item.sampleCode)
      const params = { listSampleCode, expoInfoCode: this.expoInfoCode }

      this.loadingOpen()
      const res = await this.$api.expoSampleAddApi(params).catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.chooseSampleVisible = false
      this.reload()
    },
    async usedSampleConfirm(data) {
      if (!data || !data.length) return

      const confirm = await this.$confirm(
        `${this.$l('confirm_addSample') || '是否将选中的样品添加到该展厅？'}【${
          this.expoInfoName
        }】`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const listExpoSampleCode = data.map((item) => item.expoSampleCode)
      const params = { listExpoSampleCode, expoInfoCode: this.expoInfoCode }

      this.loadingOpen()
      const res = await this.$api
        .expoSampleChooseAddApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.chooseUsedSampleVisible = false
      this.reload()
    },
    printer({ expoSampleCode }) {
      if (!expoSampleCode) return
      this.openChooseTemolate([expoSampleCode])
    },
    printers() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_printersEmptyData') || '请选择需要打印的展品',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRows.map((row) => row.expoSampleCode)
      this.openChooseTemolate(listCode)
    },
    exportData() {
      const listCode = this.checkedRows.map((row) => row.expoSampleCode)
      const form = this.$refs.header.getForm()
      const data = {
        listExpoSampleCode: listCode,
        ...(form || {}),
        expoInfoCode: this.expoInfoCode,
      }
      this.loadingOpen()
      this.$api
        .SYS_EXPORT_TASK('factory-factory-digicenter-sample', { ...data })
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            this.clearCheckboxRow()
            return
          } else {
            this.$message.error(
              this.$l('INDEX.Description_Failed_to_add_export_task') ||
                '导出任务添加失败'
            )
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
    },
    openChooseTemolate(listCode) {
      this.chooseTemplateOptions = { visible: true, listCode }
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
<style lang="scss" scoped>
.printer-button {
  .el-icon-circle-close {
    display: none;
  }
}
.printer-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
